import React from 'react';
import {Container} from './styles/buttons';
import {
    Btn
} from './styles/buttons';



export default function Buttons({children,...restProps}) {
    return <Container {...restProps}>{children}</Container>
}

Buttons.Button = function Button({children, buttonType, ...restProps}) {
    return <Btn variant="contained" {...restProps}>{children}</Btn>
}